import template from './deposit_packing.html';
import controller from './deposit_packing.controller';
import './deposit_packing.scss';

let depositPackingComponent = {
    restrict: 'E',
    template,
    controller
};

export default depositPackingComponent;



// WEBPACK FOOTER //
// ./client/app/components/deposit_packing/deposit_packing.component.js